<template>
  <div class="prediction">
    <div class="bg-decoration">
      <svg class="molecule-bg molecule-bg-1" viewBox="0 0 400 400" fill="none">
        <circle cx="200" cy="80" r="6" fill="#fca5a5" opacity="0.6"/>
        <circle cx="120" cy="140" r="5" fill="#fca5a5" opacity="0.5"/>
        <circle cx="280" cy="140" r="7" fill="#fca5a5" opacity="0.7"/>
        <circle cx="80" cy="220" r="4" fill="#fca5a5" opacity="0.4"/>
        <circle cx="200" cy="200" r="8" fill="#fca5a5" opacity="0.8"/>
        <circle cx="320" cy="220" r="5" fill="#fca5a5" opacity="0.5"/>
        <circle cx="150" cy="280" r="6" fill="#fca5a5" opacity="0.6"/>
        <circle cx="250" cy="280" r="5" fill="#fca5a5" opacity="0.5"/>
        <circle cx="200" cy="350" r="4" fill="#fca5a5" opacity="0.4"/>
        <line x1="200" y1="80" x2="120" y2="140" stroke="#fca5a5" stroke-width="1" opacity="0.3"/>
        <line x1="200" y1="80" x2="280" y2="140" stroke="#fca5a5" stroke-width="1" opacity="0.3"/>
        <line x1="120" y1="140" x2="80" y2="220" stroke="#fca5a5" stroke-width="1" opacity="0.3"/>
        <line x1="120" y1="140" x2="200" y2="200" stroke="#fca5a5" stroke-width="1" opacity="0.3"/>
        <line x1="280" y1="140" x2="200" y2="200" stroke="#fca5a5" stroke-width="1" opacity="0.3"/>
        <line x1="280" y1="140" x2="320" y2="220" stroke="#fca5a5" stroke-width="1" opacity="0.3"/>
        <line x1="200" y1="200" x2="150" y2="280" stroke="#fca5a5" stroke-width="1" opacity="0.3"/>
        <line x1="200" y1="200" x2="250" y2="280" stroke="#fca5a5" stroke-width="1" opacity="0.3"/>
        <line x1="150" y1="280" x2="200" y2="350" stroke="#fca5a5" stroke-width="1" opacity="0.3"/>
        <line x1="250" y1="280" x2="200" y2="350" stroke="#fca5a5" stroke-width="1" opacity="0.3"/>
        <line x1="80" y1="220" x2="150" y2="280" stroke="#fca5a5" stroke-width="1" opacity="0.3"/>
        <line x1="320" y1="220" x2="250" y2="280" stroke="#fca5a5" stroke-width="1" opacity="0.3"/>
      </svg>

      <svg class="bars-bg" viewBox="0 0 200 300" fill="none">
        <rect x="10" y="150" width="12" height="150" fill="#fca5a5" opacity="0.15"/>
        <rect x="30" y="100" width="12" height="200" fill="#fca5a5" opacity="0.12"/>
        <rect x="50" y="120" width="12" height="180" fill="#fca5a5" opacity="0.18"/>
        <rect x="70" y="80" width="12" height="220" fill="#fca5a5" opacity="0.1"/>
        <rect x="90" y="140" width="12" height="160" fill="#fca5a5" opacity="0.15"/>
        <rect x="110" y="90" width="12" height="210" fill="#fca5a5" opacity="0.13"/>
        <rect x="130" y="110" width="12" height="190" fill="#fca5a5" opacity="0.16"/>
        <rect x="150" y="70" width="12" height="230" fill="#fca5a5" opacity="0.09"/>
        <rect x="170" y="130" width="12" height="170" fill="#fca5a5" opacity="0.14"/>
      </svg>

      <svg class="network-bg" viewBox="0 0 300 200" fill="none">
        <circle cx="50" cy="50" r="5" fill="#f87171" opacity="0.4"/>
        <circle cx="120" cy="30" r="4" fill="#f87171" opacity="0.3"/>
        <circle cx="200" cy="60" r="6" fill="#f87171" opacity="0.5"/>
        <circle cx="270" cy="40" r="5" fill="#f87171" opacity="0.4"/>
        <circle cx="80" cy="120" r="4" fill="#f87171" opacity="0.3"/>
        <circle cx="150" cy="100" r="7" fill="#f87171" opacity="0.6"/>
        <circle cx="230" cy="130" r="5" fill="#f87171" opacity="0.4"/>
        <circle cx="180" cy="170" r="6" fill="#f87171" opacity="0.5"/>
        <circle cx="100" cy="180" r="4" fill="#f87171" opacity="0.3"/>
        <line x1="50" y1="50" x2="120" y2="30" stroke="#f87171" stroke-width="1" opacity="0.2"/>
        <line x1="120" y1="30" x2="200" y2="60" stroke="#f87171" stroke-width="1" opacity="0.2"/>
        <line x1="200" y1="60" x2="270" y2="40" stroke="#f87171" stroke-width="1" opacity="0.2"/>
        <line x1="50" y1="50" x2="80" y2="120" stroke="#f87171" stroke-width="1" opacity="0.2"/>
        <line x1="80" y1="120" x2="150" y2="100" stroke="#f87171" stroke-width="1" opacity="0.2"/>
        <line x1="150" y1="100" x2="200" y2="60" stroke="#f87171" stroke-width="1" opacity="0.2"/>
        <line x1="150" y1="100" x2="230" y2="130" stroke="#f87171" stroke-width="1" opacity="0.2"/>
        <line x1="230" y1="130" x2="270" y2="40" stroke="#f87171" stroke-width="1" opacity="0.2"/>
        <line x1="80" y1="120" x2="100" y2="180" stroke="#f87171" stroke-width="1" opacity="0.2"/>
        <line x1="100" y1="180" x2="180" y2="170" stroke="#f87171" stroke-width="1" opacity="0.2"/>
        <line x1="180" y1="170" x2="230" y2="130" stroke="#f87171" stroke-width="1" opacity="0.2"/>
        <line x1="150" y1="100" x2="180" y2="170" stroke="#f87171" stroke-width="1" opacity="0.2"/>
      </svg>
    </div>

    <div class="prediction-content">
      <div class="header-section">
        <h1 class="page-title">Prediction</h1>
        <p class="page-subtitle">Multi-omics prediction models and prognostic analytics for disease risk assessment.</p>
      </div>

      <div class="config-section">
        <div class="config-card">
          <h3 class="config-title">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <circle cx="12" cy="12" r="3"></circle>
              <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"></path>
            </svg>
            Model Configuration
          </h3>
          <div class="config-form">
            <div class="form-row">
              <div class="form-group">
                <label class="form-label">Disease</label>
                <el-select v-model="selectedDisease" placeholder="Select disease" size="small" class="form-select">
                  <el-option v-for="d in diseases" :key="d" :label="d" :value="d"></el-option>
                </el-select>
              </div>
              <div class="form-group">
                <label class="form-label">Omics Layer</label>
                <el-select v-model="selectedOmics" placeholder="Select omics layer" size="small" class="form-select">
                  <el-option v-for="o in omicsLayers" :key="o" :label="o" :value="o"></el-option>
                </el-select>
              </div>
              <div class="form-group">
                <label class="form-label">Model Type</label>
                <el-select v-model="selectedModel" placeholder="Select model" size="small" class="form-select">
                  <el-option v-for="m in modelTypes" :key="m" :label="m" :value="m"></el-option>
                </el-select>
              </div>
              <el-button type="danger" @click="handlePredict" size="small" class="predict-btn">
                <i class="el-icon-data-analysis"></i>
                Run Prediction
              </el-button>
            </div>
          </div>
        </div>
      </div>

      <div class="results-area" v-if="showResults">
        <div class="results-grid">
          <div class="metric-card">
            <div class="metric-icon" style="background: #fef2f2; color: #ef4444;">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <polyline points="22 12 18 12 15 21 9 3 6 12 2 12"></polyline>
              </svg>
            </div>
            <div class="metric-info">
              <div class="metric-value">0.847</div>
              <div class="metric-label">AUC-ROC</div>
            </div>
          </div>

          <div class="metric-card">
            <div class="metric-icon" style="background: #fef2f2; color: #ef4444;">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <line x1="18" y1="20" x2="18" y2="10"></line>
                <line x1="12" y1="20" x2="12" y2="4"></line>
                <line x1="6" y1="20" x2="6" y2="14"></line>
              </svg>
            </div>
            <div class="metric-info">
              <div class="metric-value">0.791</div>
              <div class="metric-label">AUC-PR</div>
            </div>
          </div>

          <div class="metric-card">
            <div class="metric-icon" style="background: #fef2f2; color: #ef4444;">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
                <polyline points="22 4 12 14.01 9 11.01"></polyline>
              </svg>
            </div>
            <div class="metric-info">
              <div class="metric-value">76.3%</div>
              <div class="metric-label">Accuracy</div>
            </div>
          </div>

          <div class="metric-card">
            <div class="metric-icon" style="background: #fef2f2; color: #ef4444;">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
              </svg>
            </div>
            <div class="metric-info">
              <div class="metric-value">0.823</div>
              <div class="metric-label">F1 Score</div>
            </div>
          </div>
        </div>

        <div class="charts-row">
          <div class="chart-panel">
            <div class="panel-header">
              <div class="panel-title">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <polyline points="22 12 18 12 15 21 9 3 6 12 2 12"></polyline>
                </svg>
                ROC Curve
              </div>
              <div class="panel-subtitle">Receiver Operating Characteristic</div>
            </div>
            <div class="chart-container">
              <svg class="roc-chart" viewBox="0 0 300 300" fill="none">
                <line x1="40" y1="260" x2="280" y2="260" stroke="#e5e7eb" stroke-width="1"/>
                <line x1="40" y1="260" x2="40" y2="20" stroke="#e5e7eb" stroke-width="1"/>
                <line x1="40" y1="260" x2="280" y2="20" stroke="#e5e7eb" stroke-width="1" stroke-dasharray="4 4"/>
                <text x="35" y="20" text-anchor="end" font-size="10" fill="#9ca3af">1.0</text>
                <text x="35" y="80" text-anchor="end" font-size="10" fill="#9ca3af">0.8</text>
                <text x="35" y="140" text-anchor="end" font-size="10" fill="#9ca3af">0.6</text>
                <text x="35" y="200" text-anchor="end" font-size="10" fill="#9ca3af">0.4</text>
                <text x="35" y="260" text-anchor="end" font-size="10" fill="#9ca3af">0.0</text>
                <text x="40" y="275" text-anchor="middle" font-size="10" fill="#9ca3af">0.0</text>
                <text x="100" y="275" text-anchor="middle" font-size="10" fill="#9ca3af">0.2</text>
                <text x="160" y="275" text-anchor="middle" font-size="10" fill="#9ca3af">0.4</text>
                <text x="220" y="275" text-anchor="middle" font-size="10" fill="#9ca3af">0.6</text>
                <text x="280" y="275" text-anchor="middle" font-size="10" fill="#9ca3af">1.0</text>
                <path d="M40 260 L40 258 L52 256 L64 252 L76 245 L88 234 L100 218 L112 196 L124 170 L136 142 L148 114 L160 88 L172 68 L184 52 L196 42 L208 34 L220 29 L232 26 L244 24 L256 22 L268 21 L280 20"
                      stroke="#ef4444" stroke-width="2.5" fill="none" stroke-linecap="round"/>
                <path d="M40 260 L40 258 L52 256 L64 252 L76 245 L88 234 L100 218 L112 196 L124 170 L136 142 L148 114 L160 88 L172 68 L184 52 L196 42 L208 34 L220 29 L232 26 L244 24 L256 22 L268 21 L280 20 L280 260 Z"
                      fill="#ef4444" opacity="0.08"/>
                <text x="100" y="190" font-size="12" fill="#991b1b" font-weight="600">AUC = 0.847</text>
                <text x="160" y="295" text-anchor="middle" font-size="11" fill="#6b7280">False Positive Rate</text>
                <text x="12" y="140" text-anchor="middle" font-size="11" fill="#6b7280" transform="rotate(-90 12 140)">True Positive Rate</text>
              </svg>
            </div>
          </div>

          <div class="chart-panel">
            <div class="panel-header">
              <div class="panel-title">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <line x1="18" y1="20" x2="18" y2="10"></line>
                  <line x1="12" y1="20" x2="12" y2="4"></line>
                  <line x1="6" y1="20" x2="6" y2="14"></line>
                </svg>
                Feature Importance
              </div>
              <div class="panel-subtitle">Top 8 features by importance score</div>
            </div>
            <div class="chart-container">
              <svg class="importance-chart" viewBox="0 0 320 260" fill="none">
                <line x1="90" y1="15" x2="90" y2="245" stroke="#e5e7eb" stroke-width="1"/>
                <line x1="90" y1="245" x2="305" y2="245" stroke="#e5e7eb" stroke-width="1"/>
                <g>
                  <text x="85" y="30" text-anchor="end" font-size="11" fill="#6b7280">Glucose</text>
                  <rect x="92" y="20" width="200" height="16" rx="3" fill="#991b1b"/>
                  <text x="298" y="32" font-size="10" fill="#374151">0.187</text>
                </g>
                <g>
                  <text x="85" y="58" text-anchor="end" font-size="11" fill="#6b7280">HbA1c</text>
                  <rect x="92" y="48" width="168" height="16" rx="3" fill="#ef4444"/>
                  <text x="266" y="60" font-size="10" fill="#374151">0.156</text>
                </g>
                <g>
                  <text x="85" y="86" text-anchor="end" font-size="11" fill="#6b7280">BMI</text>
                  <rect x="92" y="76" width="140" height="16" rx="3" fill="#f87171"/>
                  <text x="238" y="88" font-size="10" fill="#374151">0.130</text>
                </g>
                <g>
                  <text x="85" y="114" text-anchor="end" font-size="11" fill="#6b7280">Insulin</text>
                  <rect x="92" y="104" width="112" height="16" rx="3" fill="#fca5a5"/>
                  <text x="210" y="116" font-size="10" fill="#374151">0.104</text>
                </g>
                <g>
                  <text x="85" y="142" text-anchor="end" font-size="11" fill="#6b7280">Triglycerides</text>
                  <rect x="92" y="132" width="86" height="16" rx="3" fill="#fca5a5"/>
                  <text x="184" y="144" font-size="10" fill="#374151">0.080</text>
                </g>
                <g>
                  <text x="85" y="170" text-anchor="end" font-size="11" fill="#6b7280">Age</text>
                  <rect x="92" y="160" width="68" height="16" rx="3" fill="#fecaca"/>
                  <text x="166" y="172" font-size="10" fill="#374151">0.063</text>
                </g>
                <g>
                  <text x="85" y="198" text-anchor="end" font-size="11" fill="#6b7280">Sex</text>
                  <rect x="92" y="188" width="46" height="16" rx="3" fill="#fecaca"/>
                  <text x="144" y="200" font-size="10" fill="#374151">0.043</text>
                </g>
                <g>
                  <text x="85" y="226" text-anchor="end" font-size="11" fill="#6b7280">HDL-C</text>
                  <rect x="92" y="216" width="30" height="16" rx="3" fill="#fee2e2"/>
                  <text x="128" y="228" font-size="10" fill="#374151">0.028</text>
                </g>
              </svg>
            </div>
          </div>
        </div>

        <div class="model-details">
          <div class="detail-panel">
            <div class="panel-header">
              <div class="panel-title">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                  <polyline points="14 2 14 8 20 8"></polyline>
                </svg>
                Model Details
              </div>
            </div>
            <div class="details-grid">
              <div class="detail-item" v-for="(val, key) in modelDetails" :key="key">
                <span class="detail-key">{{ key }}</span>
                <span class="detail-val">{{ val }}</span>
              </div>
            </div>
          </div>

          <div class="detail-panel">
            <div class="panel-header">
              <div class="panel-title">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
                </svg>
                Confusion Matrix
              </div>
            </div>
            <div class="confusion-matrix">
              <div class="cm-grid">
                <div class="cm-cell cm-header">Pred Positive</div>
                <div class="cm-cell cm-header">Pred Negative</div>
                <div class="cm-cell cm-row-header">Act Positive</div>
                <div class="cm-cell cm-tp">847</div>
                <div class="cm-cell cm-fn">153</div>
                <div class="cm-cell cm-row-header">Act Negative</div>
                <div class="cm-cell cm-fp">212</div>
                <div class="cm-cell cm-tn">788</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Prediction',
  data() {
    return {
      selectedDisease: '',
      selectedOmics: '',
      selectedModel: '',
      showResults: false,
      diseases: [
        'Type 2 Diabetes',
        'Essential Hypertension',
        'Non-alcoholic Fatty Liver Disease',
        'Chronic Obstructive Pulmonary Disease',
        'Major Depression Disorder',
        'Dementia'
      ],
      omicsLayers: [
        'Metabolomics + Genomics',
        'Proteomics + Genomics',
        'Multi-omics (All)',
        'Genomics Only',
        'Metabolomics Only'
      ],
      modelTypes: [
        'LASSO Logistic Regression',
        'Random Forest',
        'XGBoost',
        'Neural Network',
        'Elastic Net'
      ],
      modelDetails: {
        'Algorithm': 'XGBoost',
        'Training Samples': '389,712',
        'Test Samples': '97,500',
        'Cross-validation': '5-fold',
        'Feature Count': '2,847',
        'Hyperparameters': 'max_depth=6, eta=0.1',
        'Training Time': '4m 32s',
        'Best Iteration': '247'
      }
    }
  },
  methods: {
    handlePredict() {
      this.showResults = true
    }
  }
}
</script>

<style lang="less" scoped>
.prediction {
  min-height: 100%;
  position: relative;
  overflow: hidden;
  background: linear-gradient(180deg, #fef2f2 0%, #ffffff 100%);
}

.bg-decoration {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  pointer-events: none;
  overflow: hidden;
}

.molecule-bg {
  position: absolute;
  width: 400px;
  height: 400px;
  top: 20px;
  left: -50px;
}

.bars-bg {
  position: absolute;
  width: 200px;
  height: 300px;
  bottom: 80px;
  left: -20px;
}

.network-bg {
  position: absolute;
  width: 350px;
  height: 250px;
  bottom: 60px;
  right: -30px;
}

.prediction-content {
  position: relative;
  z-index: 1;
  max-width: 1400px;
  margin: 0 auto;
  padding: 24px 16px;
  display: flex;
  flex-direction: column;
  min-height: calc(100vh - 64px);
}

.header-section {
  text-align: center;
  margin-bottom: 20px;
}

.page-title {
  font-size: 40px;
  font-weight: 700;
  color: #1f2937;
  margin: 0 0 8px 0;
  line-height: 1.3;
}

.page-subtitle {
  font-size: 16px;
  color: #6b7280;
  margin: 0;
  line-height: 1.6;
}

.config-section {
  margin-bottom: 24px;
}

.config-card {
  background: #ffffff;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  border: 1px solid #e5e7eb;
  padding: 20px 24px;
}

.config-title {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 16px;
  font-weight: 600;
  color: #1f2937;
  margin: 0 0 16px 0;

  svg {
    width: 20px;
    height: 20px;
    color: #ef4444;
  }
}

.config-form {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.form-row {
  display: flex;
  gap: 16px;
  align-items: flex-end;
  flex-wrap: wrap;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.form-label {
  font-size: 14px;
  font-weight: 500;
  color: #374151;
}

.form-select {
  min-width: 200px;
}

.predict-btn {
  margin-left: 8px;
}

.results-area {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.results-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;
}

.metric-card {
  background: #ffffff;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  border: 1px solid #e5e7eb;
  padding: 20px;
  display: flex;
  align-items: center;
  gap: 16px;
}

.metric-icon {
  width: 48px;
  height: 48px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;

  svg {
    width: 24px;
    height: 24px;
  }
}

.metric-info {
  display: flex;
  flex-direction: column;
}

.metric-value {
  font-size: 24px;
  font-weight: 700;
  color: #1f2937;
  line-height: 1.2;
}

.metric-label {
  font-size: 13px;
  color: #9ca3af;
  margin-top: 2px;
}

.charts-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
}

.chart-panel {
  background: #ffffff;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  border: 1px solid #e5e7eb;
  display: flex;
  flex-direction: column;
}

.panel-header {
  padding: 12px 16px;
  border-bottom: 1px solid #f3f4f6;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
}

.panel-title {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 15px;
  font-weight: 600;
  color: #1f2937;

  svg {
    width: 18px;
    height: 18px;
    color: #ef4444;
  }
}

.panel-subtitle {
  font-size: 12px;
  color: #9ca3af;
  flex: 1;
}

.chart-container {
  padding: 16px;
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}

.roc-chart {
  width: 100%;
  max-width: 300px;
  height: 300px;
}

.importance-chart {
  width: 100%;
  height: 260px;
}

.model-details {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
}

.detail-panel {
  background: #ffffff;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  border: 1px solid #e5e7eb;
}

.details-grid {
  padding: 16px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
}

.detail-item {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 8px 0;
  border-bottom: 1px solid #f3f4f6;
}

.detail-key {
  font-size: 12px;
  color: #9ca3af;
}

.detail-val {
  font-size: 14px;
  font-weight: 600;
  color: #1f2937;
}

.confusion-matrix {
  padding: 24px;
  display: flex;
  justify-content: center;
}

.cm-grid {
  display: grid;
  grid-template-columns: auto 1fr 1fr;
  gap: 4px;
  max-width: 320px;
  width: 100%;
}

.cm-cell {
  padding: 16px;
  text-align: center;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
}

.cm-header {
  background: #f9fafb;
  color: #6b7280;
  font-size: 13px;
}

.cm-row-header {
  background: #f9fafb;
  color: #6b7280;
  font-size: 13px;
  writing-mode: horizontal-tb;
}

.cm-tp {
  background: #fef2f2;
  color: #991b1b;
  font-weight: 700;
  font-size: 18px;
}

.cm-fn {
  background: #fefce8;
  color: #a16207;
  font-weight: 700;
  font-size: 18px;
}

.cm-fp {
  background: #fefce8;
  color: #a16207;
  font-weight: 700;
  font-size: 18px;
}

.cm-tn {
  background: #f0fdf4;
  color: #166534;
  font-weight: 700;
  font-size: 18px;
}

@media (max-width: 1200px) {
  .charts-row {
    grid-template-columns: 1fr;
  }

  .model-details {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 900px) {
  .results-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 768px) {
  .prediction-content {
    padding: 24px 16px;
  }

  .page-title {
    font-size: 28px;
  }

  .form-row {
    flex-direction: column;
    align-items: stretch;
  }

  .form-select {
    min-width: 100%;
  }

  .results-grid {
    grid-template-columns: 1fr;
  }
}
</style>
